import React from 'react';

import './header.css'

import logo from '../../assets/images/logo.jpg'
import { Icon } from 'semantic-ui-react'

const Header = ({openBurger, isOpen, title }) => {
    const className = isOpen ? 'burgerOpen' : 'burger'

    return (
        <header className="header">

            <div className="phone">
                <div onClick={()=>{
                    openBurger()
                }} className={className}>
                    <span></span>
                </div>
            </div>



            <div  className="header__image">
                <img className="header__logo " src={logo} alt='logo' />
                <h1 className="header__title">{title}</h1>
                <p className="header__description">un sublime dessert pour vos événements :<br />anniversaire, mariage, baby shower </p>
                <span  className="header__trait"></span>

               <div className="insta animate__animated animate__bounce animate__delay-2s"> <a href="https://www.instagram.com/les_delices_de_lylia/?igshid=x9kghvw1tu1" target="_blank" rel="noreferrer" > <Icon name='instagram' size='huge' /></a></div>
               <div className="insta_mobile animate__animated animate__bounce animate__delay-2s"><a href="https://www.instagram.com/les_delices_de_lylia/?igshid=x9kghvw1tu1" target="_blank" rel="noreferrer" > <Icon name='instagram' size='big' /></a></div>

            </div>
        </header>
    );
};

export default Header;